export default class AsyncEventHandler {
    readonly name: string;

    constructor(name: string) {
        this.name = name;
    }

    private get eventName(): string {
        return `AsyncEventHandler-${this.name}`;
    }

    waitFor(): Promise<void> {
        return new Promise<void>((resolve) => {
            window.addEventListener(this.eventName, () => {
                resolve();
            });
        });
    }

    /** Subscribes to every occurrence of the event. Returns the function that cancels the subscription. */
    subscribe(listener: () => void): () => void {
        const handler = () => listener();

        window.addEventListener(this.eventName, handler);

        return () => window.removeEventListener(this.eventName, handler);
    }

    trigger() {
        window.dispatchEvent(new Event(this.eventName));
    }
}
